'use client';

import { use } from 'react';

import { User } from '../../shared/models/user.model';
import { AuthenticationContext } from '../contexts/authentication-context';

export interface UseAuthenticationValue {
   user: User | undefined;
   loading: boolean;
   canAuthenticate: boolean;
   accessToken: string | undefined;
   login: (redirectUrl?: string, language?: string) => void;
   refreshToken: () => Promise<void>;
   logout: () => void;
}

export const useAuthentication = (): UseAuthenticationValue => {
   const context = use(AuthenticationContext);
   if (!context) {
      throw new Error('useAuthenticationContext must be used within a AuthenticationContextProvider');
   }
   return context;
};
